import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from "storybookComponents/Typography";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import { Collapse } from "reactstrap";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 660,
    background: "white !important",
    borderRadius: "0 !important",
    boxShadow: "none",
    border: "2px solid #e3dede",
    padding: 20,
    paddingRight: 0,
    fontFamily: "Open Sans !important",
    fontStyle: "normal !important"
  },
  heading: {
    fontSize: 16,
    color: "black",
    fontFamily: "Open Sans",
    display: "flex",
    alignItems: "center",
    fontWeight: 600
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: -8,
  },
  headerLeft: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    width: "-webkit-fill-available",

  },
  paper: {
    padding: 0
  },
  paperContent: {
    width: "100%",
    paddingLeft: "16px"
  },
  openIcon: {
    transform: "rotate(90deg)"
  },
  subtitle: {
    fontFamily: "Open Sans !important",
    fontStyle: "normal !important",
    marginTop: 12,
    color: "rgba(51,51,51,0.5)",
    fontSize: 14,
  },
  greyed: {
    backgroundColor: "#F9F9F9 !important"
  }
}));

export default function Expansion({ expanded, name, handleExpandedPanel, header, headerIcon, subtitle, rightSection, children, greyed, defaultOpen, icon }) {
  const classes = useStyles();

  return (
    <div >
      <div className={classes.header}>
        <div className={classes.headerLeft} onClick={() => handleExpandedPanel(name)}>
          {
            icon == "arrow" ? <ArrowRightIcon className={`${expanded && classes.openIcon}`} /> : <ChevronRightIcon className={`${expanded && classes.openIcon}`} />
          }

          <Typography className={classes.heading}>{typeof header === "function" ? header(expanded) : header} {headerIcon ? typeof headerIcon === "function" ? headerIcon(expanded) : headerIcon : null}</Typography>
        </div>
        <div>
          {rightSection ? typeof rightSection === "function" ? rightSection(expanded) : rightSection : null}
        </div>
      </div>
      {
        <Collapse isOpen={expanded}>
          <div className={classes.paperContent}>
            {
              subtitle ? <Typography className={classes.subtitle} type="subtitle" color="darkBlack">
                {subtitle}
              </Typography>
                : null
            }
            {children}
          </div>
        </Collapse>
      }
    </div>
  );
}